// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #89CFF0; /* Updated backgroundssss color */
  /* padding: 20px;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.2em;
  cursor: pointer;
}

.form-group {
  margin-bottom: 15px;
 
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button[type="submit"] {
  background-color:#0E4C92;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

button[type="submit"]:hover {
  background-color: #0056b3;
} */ 

/* Full page container */
.signup-page-container {
  display: flex;
  min-height: 100vh;
  background-color: #f9f9f9;
}

/* Feature Section */
.feature-section {
  flex: 1 1;
  padding: 20px;
  background-color: #fff;
  border-right: 2px solid #ccc; /* Optional divider */
}

.feature-section h2 {
  text-align: center;
  margin-bottom: 20px;
}

.features-list {
  list-style: none;
  padding-left: 0;
  text-align: left;
}

.features-list li {
  margin-bottom: 10px;
  font-size: 16px;
}

/* Form Section */
.form-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.signup-header h2 {
  text-align: center;
  margin-top: 20px;
}

/* Form */
.signup-form .form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.signup-form label {
  font-weight: bold;
  margin-bottom: 5px;
}

.signup-form input {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Terms and Submit Button */
.terms {
  font-size: 12px;
  margin-bottom: 15px;
  text-align: center;
}

.signup-button {
  width: 100%;
  padding: 10px;
  background-color: #0b72b9;
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.signup-button:hover {
  background-color: #082850;
}
.logo {
  font-size: 24px;
  margin-bottom: 20px;
  align-self: flex-start; /* Align to the left */
}`, "",{"version":3,"sources":["webpack://./src/CustomerInfoModal.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;wDAcwD;EACtD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8CC;;AAEH,wBAAwB;AACxB;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4BAA4B,EAAE,qBAAqB;AACrD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB,EAAE,sBAAsB;AAChD","sourcesContent":["/* .modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #89CFF0; /* Updated backgroundssss color */\n  /* padding: 20px;\n  border-radius: 8px;\n  width: 400px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 1.2em;\n  cursor: pointer;\n}\n\n.form-group {\n  margin-bottom: 15px;\n \n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\nbutton[type=\"submit\"] {\n  background-color:#0E4C92;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbutton[type=\"submit\"]:hover {\n  background-color: #0056b3;\n} */ \n\n/* Full page container */\n.signup-page-container {\n  display: flex;\n  min-height: 100vh;\n  background-color: #f9f9f9;\n}\n\n/* Feature Section */\n.feature-section {\n  flex: 1;\n  padding: 20px;\n  background-color: #fff;\n  border-right: 2px solid #ccc; /* Optional divider */\n}\n\n.feature-section h2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.features-list {\n  list-style: none;\n  padding-left: 0;\n  text-align: left;\n}\n\n.features-list li {\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n/* Form Section */\n.form-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.signup-header h2 {\n  text-align: center;\n  margin-top: 20px;\n}\n\n/* Form */\n.signup-form .form-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n\n.signup-form label {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.signup-form input {\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Terms and Submit Button */\n.terms {\n  font-size: 12px;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.signup-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #0b72b9;\n  color: white;\n  font-size: 16px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.signup-button:hover {\n  background-color: #082850;\n}\n.logo {\n  font-size: 24px;\n  margin-bottom: 20px;\n  align-self: flex-start; /* Align to the left */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
